import { useContext, useEffect } from 'react';
import modalContext from '../context/modal/modalContext';

/**
 * Hook to display the disclaimer modal on every page load or refresh.
 */
export const useDisclaimerModal = () => {
    const { openModal } = useContext(modalContext);

    useEffect(() => {
        openModal('disclaimerModal');
    }, [openModal]);
};
